module.exports = __webpack_public_path__ + "assets/images/recipe3.d63ae4a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/activity_page/recipes/recipe3.png
// module id = 1641
// module chunks = 3